<template>
  <div class="right-bar-wrapper" :class="{ collapsed: isCollapsed }">

    <aside
      v-show="!isCollapsed"
      class="right-bar"
    >
      <NoticePanel :emergencyNotices="emergencyNotices" />

      <WeatherPanel />

      <ImagePanel :siteImages="siteImages" />
    </aside>

    <button
      class="toggle-btn"
      @click="isCollapsed = !isCollapsed"
      type="button"
    >
      <i
        :class="
          isCollapsed
            ? 'fa-solid fa-chevron-left'
            : 'fa-solid fa-chevron-right'
        "
      />
    </button>

  </div>
</template>

<script>
import NoticePanel from '@/components/client-ui/panel/NoticePanel.vue'
import WeatherPanel from '@/components/client-ui/panel/WeatherPanel.vue'
import ImagePanel from '@/components/client-ui/panel/ImagePanel.vue'

export default {
  name: 'RightBar',

  components: {
    NoticePanel,
    WeatherPanel,
    ImagePanel
  },

  props: {
    menus: {
      type: Array,
      default: () => []
    },
    activeMenu: {
      type: String,
      default: ''
    },
    siteImages: {
      type: Array,
      default: () => []
    },
    emergencyNotices: {
      type: Array,
      default: () => []
    }
  },

  data() {
    return {
      isCollapsed: false
    }
  }
}
</script>

<style scoped>
.right-bar-wrapper {
  position: relative;
  width: 320px;
  min-width: 320px;
  height: 100%;
  flex-shrink: 0;
  transition: width 0.2s ease;
}

.right-bar-wrapper.collapsed {
  width: 0;
  min-width: 0;
}

.right-bar {
  width: 320px;
  height: 100%;
  overflow-y: auto;
  overflow-x: hidden;
  padding: 12px 10px;
  box-sizing: border-box;
  background: #f5f7fa;
}

.toggle-btn {
  position: absolute;

  /* ← 1번 위치 */
  top: 50%;
  left: -18px;

  transform: translateY(-50%);

  width: 42px;
  height: 42px;

  border: none;
  border-radius: 12px;
  cursor: pointer;

  z-index: 999;

  background: var(--color-primary);
  color: #fff;

  box-shadow: 0 8px 20px rgba(0,0,0,0.15);

  display: flex;
  align-items: center;
  justify-content: center;
}

.toggle-btn i {
  font-size: 14px;
}

@media (max-width: 1200px) {
  .right-bar-wrapper {
    width: 280px;
    min-width: 280px;
  }

  .right-bar {
    width: 280px;
  }
}
</style>